module.exports = __webpack_public_path__ + "02_medium_brown.c639f918.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_medium_brown.png
// module id = xSEf
// module chunks = 0